import { Navigate, Outlet } from 'react-router-dom';

const SuperAdminGuard = () => {
  const userJson = localStorage.getItem('user');
  
  if (!userJson) {
    return <Navigate to="/dashboard" replace />;
  }

  try {
    const user = JSON.parse(userJson);
    if (user.role !== 'super_admin') {
      return <Navigate to="/dashboard" replace />;
    }
  } catch {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default SuperAdminGuard;
